module.exports = __webpack_public_path__ + "img/cover.31b266f1.jpg";